import React from 'react'
import ContactForm from '../ContactUsForm'
import TermsAndConditionsModal from '../TermsAndConditionsModal'
import ApplyNowButton from "../ApplyNowButton"
import Modal from '../Modal'
import './styles.scss'

class ContactOptionsModal extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      utmParams, onCloseTerms, onOpenTerms, showTerms = false,
      onOpenScheduleTour, currentListing={}, ...modalProps
    } = this.props;

    return (
      <Modal persistent={true} id='contactOptionsModal' {...modalProps}>
        <div className="contact-options-modal__cta-buttons modal__noFocus">
          <ApplyNowButton className="contact-options-modal__cta-button modal__noFocus" />
          <a tabIndex="0" className="button contact-options-modal__cta-button modal__noFocus" onClick={onOpenScheduleTour} onKeyPress={onOpenScheduleTour}>Book A Tour</a>
        </div>

        <ContactForm utmParams={utmParams} openTerms={onOpenTerms} className="contact-options-modal__contact-us-form" currentListing={currentListing} />
        <TermsAndConditionsModal isOpened={showTerms} onClose={onCloseTerms} persistent={false} />
      </Modal>
    );
    }
}

export default ContactOptionsModal;


// WEBPACK FOOTER //
// ./client/components/ContactOptionsModal/index.js